import camelCase from './camelCase';

class Router {
    constructor(routes) {
        this.routes = routes;
    }

    fire(route, type = 'init') {
        const routeObject = this.routes[route];
        const routeFunction = routeObject && routeObject[type];
        if (typeof routeFunction === 'function') {
            routeFunction.call(routeObject);
        }
    }

    loadEvents() {
        // Fire common init
        this.fire('common');

        // Fire page-specific init
        document.body.className
            .toLowerCase()
            .replace(/-/g, '_')
            .split(/\s+/)
            .map(camelCase)
            .forEach(route => {
                this.fire(route);
            });

        // Fire common finalize
        this.fire('common', 'finalize');

        // Fire page-specific finalize
        document.body.className
            .toLowerCase()
            .replace(/-/g, '_')
            .split(/\s+/)
            .map(camelCase)
            .forEach(route => {
                this.fire(route, 'finalize');
            });
    }
}

export default Router;
